import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { DictSelect as LocalDictSelect } from '../../components/DictSelect'

export const DictSelect = connect(
  LocalDictSelect,
  mapReadPretty(LocalDictSelect, { disabled: true } as any)
)
